globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.LoadingLoader = (function()
{
    var defaults = {
        loaderGlyph : 'spinner',
        loaderSize  : 4
    }

    function LoadingLoader($container, options) {
        if($container.length === 1) {
            this.$container = $container;
            this.config = $.extend({}, defaults, options);
            this.loadingCls = 'sb-vi-loader-overlay loading';
            this.loadingText = $container.data('loading-text');
            this.$html = $('<div class="loading-container"><i class="fa fa-pulse fa-' + this.config.loaderGlyph + ' fa-' + this.config.loaderSize + 'x"></i><p class="loading-text"></p></div>').prependTo(this.$container);
            this.init();
        } else {
            throw 'LoadingLoader: Conteneur inexistant';
        }
    }

    LoadingLoader.prototype =
    {
        init : function() {
            if(this.$container.css('position') == 'static') {
                this.$container.css('position', 'relative');
            }
            this.$loader = this.$html.wrap('<div></div>').parent().hide();
        },
        loading : function(text) {
            this.$loader.addClass(this.loadingCls).show();

            var text = text || this.loadingText;

            if(text) {
              this.$html.find('.loading-text').text(text);
            }

            this._center();
        },
        finish : function(callback) {
            var me = this;
            this.$loader.fadeOut('fast', function() {
                $(this).removeClass(me.loadingCls);
                if(typeof callback === 'function') callback();
            });
        },
        remove : function() {
            this.$loader.remove();
        },
        _center : function() {
            this.$html.css({
                top  : this.$container[0].offsetHeight / 2 - this.$html[0].offsetHeight / 2,
                left : this.$container[0].offsetWidth / 2 - this.$html[0].offsetWidth / 2
            });
        }
    }

    return LoadingLoader;
})();
